import { useCatalogItemCartContext } from '../../../../providers/CatalogItemCartProvider'
import { CatalogItemDetailsPanel } from '../../views/CatalogItemDetailsPanel'

export const CatalogItemDetailsPanelPresenter = () => {
  const {
    selectedItem,
    quantity,
    estimatedTotal,
    changeQuantity,
    addToRequest,
    collapse,
  } = useCatalogItemCartContext()

  if (!selectedItem) return null

  return (
    <CatalogItemDetailsPanel
      item={selectedItem}
      quantity={quantity}
      estimatedTotal={estimatedTotal}
      onQuantityChange={changeQuantity}
      onAddToRequest={addToRequest}
      onCollapse={collapse}
    />
  )
}
